import { useTranslation } from 'react-i18next';
import { StringNode, widget, WidgetPlugin } from '@sagold/react-json-editor';

import { FormField } from '../../../components/formfield/FormField';
import { ReadOnlyInput } from '../../../components/readonly-input/ReadOnlyInput';
import { Textarea } from '../../../components/textarea/Textarea';
import { StringOptions } from '../stringwidget/StringWidget';
import {
  isNullableString,
  resolvePlaceholder,
  useErrorTransformation,
} from '../widgetUtils';

export const TextareaWidget = widget<StringNode<StringOptions>, string>(
  ({ node, options, setValue }) => {
    const { t } = useTranslation();
    const errors = useErrorTransformation(node.errors);

    return (
      <FormField
        widgetType="string"
        node={node}
        options={options}
        errors={errors}
        tableLayout={options.tableLayout}
      >
        {options.readOnly ? (
          <ReadOnlyInput
            description={options.description}
            label={options.title}
            showTitle={options.showTitle !== false}
            value={node.value}
            placeholder={options.placeholder}
            tableLayout={options.tableLayout}
          />
        ) : (
          <Textarea
            description={
              options.showTitle !== false ? options.description : undefined
            }
            error={
              errors.length > 0
                ? errors.map((e) => e.message).join('\n')
                : undefined
            }
            label={options.showTitle !== false ? options.title : undefined}
            placeholder={resolvePlaceholder(
              options.placeholder,
              t('app.forms.placeholders.textarea')
            )}
            readOnly={options.readOnly}
            required={options.required}
            disabled={options.disabled}
            value={node.value ?? ''}
            onChange={setValue}
            autosize
            minRows={options.readOnly ? 1 : 6}
            maxRows={6}
            tableLayout={options.tableLayout}
          />
        )}
      </FormField>
    );
  }
);

export const TextareaWidgetPlugin: WidgetPlugin = {
  id: 'textarea-widget',
  use: (node) =>
    isNullableString(node.schema.type) && node.schema.format === 'textarea',
  Widget: TextareaWidget,
};
